import { UserApi } from './';

const {REACT_APP_API_BASE_URL} = process.env;

export class LeadsApi {
    static getAllLeads() {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/leads`, {
            ...UserApi.GetDefualtMethod
        });
    }

    static updateLead(leadID, data) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/leads/${leadID}`, {
            ...UserApi.PostDefualtMethod,
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/leads.js